import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { fetchUsers } from '../api';

function LoginPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser, setCurrentUser } = useUser();
  const navigate = useNavigate();

  const landingPathFor = (user) =>
    user?.role === 'approver' ? '/approvals' : '/board';

  useEffect(() => {
    if (currentUser) {
      navigate(landingPathFor(currentUser), { replace: true });
      return;
    }
    fetchUsers()
      .then((res) => {
        setUsers(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError('Failed to load users. Is the API running?');
        setLoading(false);
      });
  }, [currentUser, navigate]);

  const handleSelectUser = (user) => {
    setCurrentUser(user);
    navigate(landingPathFor(user));
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1 className="login-title">Erbi</h1>
        <p className="login-subtitle">Invoice Management</p>
        <h2 className="login-heading">Select User</h2>

        {loading && <div className="loading-spinner">Loading users...</div>}
        {error && <div className="error-message">{error}</div>}

        <div className="user-grid">
          {users.map((user) => (
            <button
              key={user.id}
              className="user-card"
              onClick={() => handleSelectUser(user)}
            >
              <div className="user-avatar">
                {user.name.charAt(0).toUpperCase()}
              </div>
              <div className="user-name">{user.name}</div>
              <div className="user-role-badge">{user.role}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
